var obj = {
    /**
     * 模式
     *  true : 
     *  false : 
     */
    DEBUG : true,

    /**
     * 发布的目录
     */
    BASEURL : '',

    PROJECT_NAME : '月饼券管理系统'
}

obj.PUBLIC_IMAGES = `${obj.BASEURL}/images`;

export default obj;